/**
 * Rough client-side token estimate for a prompt string.
 *
 * We don't ship a full BPE tokenizer to the browser — instead we blend the two
 * heuristics that track GPT-style tokenization well for prompt-length English +
 * Bangla text:
 *   • ~4 characters per token
 *   • ~0.75 tokens per whitespace-delimited word (i.e. words / 0.75)
 * Averaging the two keeps the estimate stable for both dense (few long words)
 * and sparse (many short words / punctuation) text. Good enough for a live
 * counter — it is an estimate, not a billing figure.
 */
export function estimateTokens(text) {
    if (!text) return 0;
    const chars = text.length;
    const words = text.trim().split(/\s+/).filter(Boolean).length;
    if (!words) return 0;
    const byChars = chars / 4;
    const byWords = words / 0.75;
    return Math.max(1, Math.round((byChars + byWords) / 2));
}

export default estimateTokens;
